import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import DescriptionForm from "./AddDestination";

export default function EditBlog() {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <DescriptionForm
      isEdit={true}
      destinationId={id}
      onSuccess={() => navigate("/listdestination")}
    />
  );
}